import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { waitForCondition } from '../utils/waitForCondition'

export const useScrollToAnchor = () => {
    const location = useLocation()

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            const hash = location.hash.slice(1).toLowerCase()

            void waitForCondition(
                () => {
                    if (document.getElementById('page-loading-progress')) return false

                    return document.getElementById(hash)
                },
                10000,
                100
            ).then(element => {
                if (hash && element) {
                    setTimeout(() => {
                        // @ts-expect-error -- param 'behavior' is rejecting type 'instant'
                        element?.scrollIntoView({ behavior: 'instant', block: 'start' })
                        // Stop observing a certain amount of time after element detection
                        setTimeout(() => {
                            observer.disconnect()
                        }, 2000)
                    }, 100)
                }
            })
        })

        observer.observe(document.body)

        return () => {
            observer.disconnect()
        }
    }, [location])

    return null
}
